import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'englishKeywords'
})
export class EnglishKeywordsPipe implements PipeTransform {
  // keywordsの中で英文字を含むキーワードを連結して返却
  transform(keywords: object, args?: any): string {
    if (!keywords) {
      return null;
    } else {
      let englishKeywords = '';
      Object.keys(keywords).forEach(keyword => {
        // 全角文字だけではない場合
        if (!/^[^\x20-\x7e]*$/.test(keyword)) {
          if (englishKeywords === '') {
            englishKeywords = englishKeywords + keyword;
          } else {
            englishKeywords = englishKeywords + ' ' + keyword;
          }
        }
      });
      return englishKeywords;
    }
  }
}
